// extracted by mini-css-extract-plugin
module.exports = {"title":"players_title__1SAic"};